import React from 'react';
import { ButtonApp } from 'src/components/ApartmentPageV2/Button';
import clsx from 'clsx';
import { useGlobalGrid } from 'src/hooks/app/use-global-grid';
import { useStyles } from './styles';

interface BtnProps {
  name: string;
  state: boolean;
  click: (event: React.MouseEvent<HTMLButtonElement>) => void
}
interface ButtonSwitcherProps {
  firstBtn: BtnProps,
  secondBtn: BtnProps,
}

export const ButtonSwitcher: React.FC<ButtonSwitcherProps> = ({
  firstBtn,
  secondBtn,
}) => {
  const { getGridsWidth } = useGlobalGrid();
  const styles = useStyles(getGridsWidth);
  return (
    <div className={styles.assignContainer}>
      <div className="toggle-group">
        <ButtonApp
          className={`not-assigned btn ${clsx(firstBtn.state && 'active')}`}
          onClick={(event) => firstBtn.click?.(event)}
        >
          {firstBtn.name}
        </ButtonApp>
        <ButtonApp
          className={`assigned btn ${clsx(secondBtn.state && 'active')}`}
          onClick={(event) => secondBtn.click?.(event)}
        >
          {secondBtn.name}
        </ButtonApp>
      </div>
    </div>
  );
};
